import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import(/* webpackChunkName: "page" */ "./views/Home.vue"),
      meta: {
        title: "Precision Tree Care | Peak District Tree Surgeons",
        description: "We are a family run tree surgery company based in Sheffield and have been established for 15 years."
      }
    },
    {
      path: "/about-us",
      name: "about",
      component: () => import(/* webpackChunkName: "page" */ "./views/About.vue"),
      meta: {
        title: "About Precision Tree Care | Peak District Tree Surgeons",
        description: "Precision Tree Care is a small tree surgery company, started in 2002 and offering a full range of tree surgery services."
      }
    },
    {
      path: "/tree-surgery",
      name: "services",
      component: () => import(/* webpackChunkName: "page" */ "./views/Services.vue"),
      meta: {
        title: "Precision Tree Care Services | Peak District Tree Surgeons",
        description: "At Precision Tree Care we offer a full range of tree surgery services, from dismantling large trees in tight spaces to formative pruning of fruit trees."
      }
    },
    {
      path: "/equipment",
      name: "equipment",
      component: () => import(/* webpackChunkName: "page" */ "./views/Equipment.vue"),
      meta: {
        title: "Precision Tree Care Equipment | Peak District Crane Fed Chipping",
        description: "Our investments in innovative machinery allows us to provide crane fed chipping, and we can approach work with vastly increased productivity and cost-effectiveness."
      }
    },
    {
      path: "/contact-us",
      name: "contact",
      component: () => import(/* webpackChunkName: "page" */ "./views/Contact.vue"),
      meta: {
        title: "Contact Precision Tree Care | Peak District Tree Surgeons",
        description: "We would be more than happy to come and look at your tree to give you free advice and a quote."
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () => import(/* webpackChunkName: "page" */ "./views/Privacy.vue"),
      meta: {
        title: "Precision Tree Care Privacy Policy | Peak District Tree Surgeons"
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
